export const GENAI_CREATE_SESSION_SUCCESS = "GENAI_CREATE_SESSION_SUCCESS";
export const GENAI_STREAM_APPEND = "GENAI_STREAM_APPEND";
export const GENAI_CLEAR_MESSAGES = "GENAI_CLEAR_MESSAGES";
export const GENAI_LOADING = "GENAI_LOADING";
export const EMAIL_TEMPLATES = "EMAIL_TEMPLATES";
export const GENAI_CHAT_CONVERSATION = "GENAI_CHAT_CONVERSATION";
